var WDN = WDN || {};

if (typeof WDN.RecentlyViewedProducts === "undefined") {
  WDN.RecentlyViewedProducts = (function () {
    class RecentlyViewedProducts extends HTMLElement {
      constructor() {
        super();
        this.section_name = "async-recently-viewed";
        if (this.hasAttribute('data-section-name')) {
          this.section_name = this.getAttribute('data-section-name');
        }
      }

      async getURLToFetch() {
        var root = Shopify.routes.root;

        // If no history storage  - return fallback
        if (typeof ViewedProducts === "undefined") return this.fallback;

        var productHistory = new ViewedProducts();

        // If storage empty - return fallback
        if (productHistory.list.length === 0) return this.fallback;

        // Store last entry in history array
        var productHandle = productHistory.list[productHistory.list.length - 1];
        // Fetch productID based on handle
        var product = await fetch(root + "products/" + productHandle + ".json");
        // If response not good, return fallback URL
        if (!product.ok) return this.fallback;

        // Turn response to JSON
        var JSONResponse = await product.json();

        // Store product ID from JSON
        var productID = JSONResponse.product ? JSONResponse.product.id : false;

        // Final check, return fallback url if product ID does not exist
        if (!productID) return this.fallback;

        // Return recommendations API
        return (
          root +
          "recommendations/products?product_id=" +
          productID +
          "&section_id=" + this.section_name
        );
      }

      async init() {
        // Required configuration - fallback url
        this.fallback = this.getAttribute("data-fallback");

        // Validation
        if (!this.fallback || this.fallback == "blank") {
          console.warn("Configuration error ", this);
          this.innerHTML = "";
          return;
        }

        this.fallback = this.fallback + "?section_id=" + this.section_name;

        // Call
        fetch(await this.getURLToFetch())
          .then((res) => {
            return res.text();
          })
          .then((resText) => {  
            let parser = new DOMParser();
            let parsedResponse = parser.parseFromString(resText, "text/html");
            let sectionContent = parsedResponse.querySelector(".shopify-section")
            
            this.innerHTML = sectionContent.innerHTML;          
          });
      }

      connectedCallback() {
        this.init();
      }
    }

    customElements.define("recently-viewed-products", RecentlyViewedProducts);
    return RecentlyViewedProducts;
  })();
}